import { render } from "./EditGroupInPortfolio.vue?vue&type=template&id=6acd3f8c&ts=true"
import script from "./EditGroupInPortfolio.vue?vue&type=script&lang=ts"
export * from "./EditGroupInPortfolio.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__